import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatAutocomplete, MatAutocompleteSelectedEvent, MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { MatChipInput, MatChipInputEvent } from '@angular/material/chips';
import { GlobalSearchService } from 'app/services/globalsearchservice.service';
import { InventoryService } from 'app/services/inventory.service';


@Component({
	selector: 'app-chiplist-filter',
	templateUrl: './chiplist-filter.component.html',
	styleUrls: ['./chiplist-filter.component.scss']
})
export class ChiplistFilterComponent implements OnInit {
	//summit req for prdline - cat filter
	productlines: any = false;

	//chips
	visible = true;
	selectable = true;
	removable = true;
	addOnBlur = true;
	readonly separatorKeysCodes = [ENTER, COMMA] as const;
	prodCtrl = new UntypedFormControl('');
	filteredProds: any = [];
	allProds: any = [];

	@ViewChild(MatAutocompleteTrigger) autocompleteTrigger!: MatAutocompleteTrigger;
	@ViewChild('prodInput', { static: false }) prodInput: ElementRef<HTMLInputElement>;
	@ViewChild('auto', { static: false }) matAutocomplete: MatAutocomplete;

	@Output() selectionChange = new EventEmitter<any>();
	@Input() prods: any = [];

	constructor(private inventoryService: InventoryService, private globalSearchService: GlobalSearchService) { }

	ngOnInit(): void {
		this.inventoryService.getItemProductlines().subscribe((res: any) => {
			this.filteredProds = res;
			this.allProds = res;
		})

		this.prodCtrl.valueChanges.subscribe(newValue => {
			this.filter();
		});
	}


	//chips
	filter() {

		if (this.prodCtrl.value == '' || !this.prodCtrl.value) {
			this.filteredProds = [];
		} else {
			const filterval = this.prodCtrl.value.replace('*', '');
			const prodsleft = this.allProds.filter((i) => {
				if (!this.prods.find((o) => i.line_field == o.line_field)) {
					return i
				}
			})
			this.filteredProds = this.globalSearchService.filterItem(prodsleft, filterval, 'line_field,line_description')
		}
	}

	add(event: any): void {
		if (event.value == '' || event.value == '*') {
			return;
		}
		if (!this.matAutocomplete.isOpen) {
			const input = event.input;
			const value = event.value;
			if (value.includes('*')) {
				
				this.prods.push(value.trim());
			}
			if (input) {
				input.value = '';
			}
			this.prodCtrl.setValue(null);
		} else {
			if (event.value.includes('*')) {
				this.filteredProds.forEach((prod) => {
					console.log('pushing 1', event.value.trim(), prod)
					this.prods.push({ line_field: prod.line_field, line_description: prod.line_description });
				});
				event.input.value = '';
				this.prodCtrl.setValue(null);
			}
		}
		this.emit()
	}

	remove(prod: string): void {
		const index = this.prods.indexOf(prod);
		if (index >= 0) {
			this.prods.splice(index, 1);
		}
		this.emit()
	}

	selected(event: MatAutocompleteSelectedEvent): void {
		this.prods.push({ line_field: event.option.value, line_description: event.option.viewValue });
		this.prodInput.nativeElement.value = '';
		this.prodCtrl.setValue(null);
	}


	emit() {
		this.selectionChange.emit(this.prods)
	}


	clearall() {
		this.prods = [];
		this.emit();
	}

	addWildCard() {
		if(this.prodCtrl.value){
			const value = this.prodCtrl.value + '*';
			if (value != '*') {
				const event = { value: value, input: {} };
				this.add(event);
				this.prodInput.nativeElement.value = '';
				this.prodCtrl.setValue(null);
				this.autocompleteTrigger.closePanel()
			}
		}
	}


}
